export const StoredFileType = {
  ProductImage: 0,
  Datasheet: 1,
  Pinout: 2,
  ReferenceDesign: 3,
  ProductSheet: 4,
  MarketingGuide: 5,
  Other: 6,
  PcbImage: 7
};